<template>
  <Button
    fsize="f12"
    variant="download_gy"
    radius
    class="l-w-150"
    :class="{ 'is-loading': isProcessing }"
    :disabled="isProcessing"
    @click="download"
  >
    <Icon2 variant="download" :size="12" />
    <span>CSVダウンロード</span>
  </Button>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import utils from '@/utils';
import iconv from 'iconv-lite';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    surveyDate: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    gscError: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Button,
    Icon2
  },
  data() {
    return {
      isProcessing: false
    };
  },
  methods: {
    download() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      const header = `キーワード,月間検索数,競合順位,自社平均順位,GAP,競合URL,自社URL`;
      const rows = this.items
        .map(item => {
          const keyword = item.keyword;
          const searchVolume = item.searchVolume;
          const competitorSiteRank = item.competitorSiteRank;
          const ownSiteUrl = item.ownSiteUrl ? item.ownSiteUrl : '-';

          let ownSiteRank = '';
          let rankGap = '';
          if (this.gscError) {
            ownSiteRank = '-';
            rankGap = '-';
          } else if (!item.ownSiteRank) {
            ownSiteRank = '取得中';
            rankGap = '取得中';
          } else if (item.ownSiteRank == 9999) {
            ownSiteRank = '圏外';
            rankGap = '-';
          } else {
            ownSiteRank = item.ownSiteRank;
            rankGap = item.rankGap;
          }
          const competitorSitePageUrl = item.competitorSitePageUrl;

          return `${keyword},${searchVolume},${competitorSiteRank},${ownSiteRank},${rankGap},${competitorSitePageUrl},${ownSiteUrl}`;
        })
        .join('\n');
      const data = iconv.encode(`${header}\n${rows}`, 'Shift_JIS');

      const date = utils.formatDate(this.surveyDate, 'YYYY年MM月DD日');
      // ファイル名にスラッシュを入れないためドメイン名のみにする
      const reg = /^(http|https):\/\//;
      const domain = this.url.replace(reg, '');

      const fileName = `競合キーワード分析_${domain}_${date}.csv`;
      utils.downloadFile(data, fileName);

      this.isProcessing = false;
    }
  }
};
</script>
